import { httpRequest } from "@services/http";
import { bannersUrl, type Banner } from "./cmdListBanners";

/** The slim schema GET /banners/current/ returns (the server's CurrentBannerOut, MPN-2264). */
export type CurrentBanner = Pick<Banner, "uuid" | "message" | "link_text" | "link_url" | "starts_at" | "ends_at" | "status">;

export class CommandGetCurrentBanner {
  /** The Live banner, or null when nothing is live. */
  async run(): Promise<CurrentBanner | null> {
    try {
      return await httpRequest<CurrentBanner | null>(`${bannersUrl()}current/`, { method: "GET" });
    } catch (error) {
      console.error("Error fetching the current banner:", error);
      throw error;
    }
  }
}
